import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "istatistik";
var rakamService = {
    rakamlarTanimlama(rakamAdi, sayi,icon,dil) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                rakamAdi: rakamAdi,
                sayi: sayi,
                icon: icon,
                dil: dil,
                methodName: "rakamTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    rakamListesi(baslangic, limit) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                baslangic: baslangic,
                limit: limit,
                methodName: "rakamListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    rakamGuncelle(rakamKodu, rakamAdi, rakam, icon,dil) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                rakamKodu: rakamKodu,
                rakamAdi: rakamAdi,
                rakam: rakam,
                icon: icon,
                dil: dil,
                methodName: "rakamGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    rakamArsiv(rakamKodu) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                rakamKodu: rakamKodu,
                methodName: "rakamArsiv"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default rakamService

